(() => {
    angular
      .module('finance')
      .controller(
        'finance.views.netSuiteConfiguration',
        NetSuiteConfigurationController
      );
  
    NetSuiteConfigurationController.$inject = [];
  
    function NetSuiteConfigurationController() {
      const vm = this;
    }
  })();
  